import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import codeDataStore from "common/codedata/store/CodeDataStore";
import configStore from "common/config/store/ConfigStore";
import messageStore from "common/message/store/MessageStore";
import userStore from "common/user/store/UserStore";
import { configure } from "mobx";

configure({
    enforceActions: "observed"
});

(async () => {
    await userStore.updateToken();
    await Promise.all([configStore.readConfig(), userStore.readUser(), messageStore.readAll(), codeDataStore.readGlobal("/common/systemLocale")]);

    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    root.render(
        <App />
    );
})();

reportWebVitals();
/*
function NoMatch() {
    return (
        <div>
            <h2>Nothing to see here!</h2>
            <p>
                <Link to="/">Go to the home page</Link>
            </p>
        </div>
    );
}
*/
